define('Store.Profile.Tracker', [
    'Store.Cookie'
], function StoreProfileTracker(
    StoreCookie
) {
    'use strict';

    return {
        /* Sadly there is only a before Login event and not an After
        * Once an after login event is present this fn can be upgraded to use it
        * Profile does not get updated with what comes in User :(
        * */
        trackLogin: function trackLogin() {
            var user;
            var storeId;

            try {
                // eslint-disable-next-line no-underscore-dangle
                var checkoutApp = (SC._applications && SC._applications.Checkout) || SC.Application;
                user = checkoutApp
                    .getLayout()
                    .currentView
                    .childViewInstances
                    .Login
                    .Login
                    .childViewInstance
                    .model
                    .get('user');
                storeId = user && user.store && user.store.internalid;
                if (storeId) {
                    StoreCookie.set(storeId);
                }
            } catch (e) {
                console.error('ERROR ON POST LOGIN COOKIE SET', e);
            }
        }
    };
});
